import { render, staticRenderFns } from "./DeactivePostDoc.vue?vue&type=template&id=684d9c9a&"
import script from "./DeactivePostDoc.vue?vue&type=script&lang=js&"
export * from "./DeactivePostDoc.vue?vue&type=script&lang=js&"
import style0 from "./DeactivePostDoc.vue?vue&type=style&index=0&id=684d9c9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports